// reducers.js
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import test from './test';
import auth from './auth';
import problems from './problems';
import solutions from './solutions';
import sections from './sections';
import progress from './progress';
import testSolutionSet from './testSolutionSet';
import appStatus from './appStatus';
import proctor from './proctor';
import socket from './socket';
import onboarding from './onboarding';
import assessment from './assessment';
import report from './report';
import coding from './coding';
import desmond from './desmond';
import revision from './revision';
import infra from './infra';
import podBased from './podBased';
import whitelabelReducer from './whitelabel.reducer';
import aiInterview from './aiInterview';

const createRootReducer = (history, asyncReducers = {}) =>
  combineReducers({
    router: connectRouter(history),
    auth,
    test,
    problems,
    solutions,
    progress,
    sections,
    testSolutionSet,
    proctor,
    appStatus,
    socket,
    onboarding,
    report,
    assessment,
    coding,
    desmond,
    revision,
    infra,
    podBased,
    whitelabelCompanyData: whitelabelReducer,
    aiInterview,
    ...asyncReducers,
  });
export default createRootReducer;
